import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios/index';
import animations from './animations';
import globals from '../../globals';
import Heading from '../../elements/Heading';
import PlanResults from '../../modules/PlanResults';
import SpeedButtons from '../../modules/SpeedButtons';
import Errors from '../../elements/Errors';
import PricingError from '../../modules/PricingError';
import Notice from "../../elements/Notice";
import Disclaimer1 from "../../elements/Disclaimer1";
import InternetForm from "../InternetForm";
import PricingBtn from "../../elements/PricingBtn";
import InternalPricingError from "../../elements/InternalPricingError";
import LoaderText from "../../elements/LoaderText";
import { sha256 } from 'js-sha256';

class NbnEnterpriseForm extends Component {

    constructor(props) {
        super(props);

        this.honeypot = 'dob';
        this.state = {
            address: '', // is set by Addressify
            first_name: globals.getSessionVar('first_name'),
            last_name: globals.getSessionVar('last_name'),
            company: globals.getSessionVar('company'),
            email: globals.getSessionVar('email'),
            phone: globals.getSessionVar('phone'),
            speed: props.speeds[0],
            [this.honeypot]: '', //honeypot
            errors: [],
            formSubmitted: false,
            plans: [],
            inProgress: false
        };
    }

    componentDidMount() {
        this.controller = globals.genericAnimation(this.content);
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.reset();
        globals.pushGA4Events(this.props.eventNameSubmit,
            {
                eventInfo: {
                    planName: this.state.speed,
                    hashedFirstName: sha256(this.state.first_name),
                    hashedLastName: sha256(this.state.last_name),
                    hashedEmail: sha256(this.state.email),
                    hashedPhoneNumber: sha256(this.state.phone),
                    pageCategory: 'Business',
                }
            });
        animations.showLoader(this);
        this.setProgress(true);
        this.submitCustomerDetails().then(() => {});
        this.getPricing().then(() => {});
    }

    handleSpeedChange(value, event) {
        if (!this.state.inProgress) {
            if (event) {
                animations.setActive(event.currentTarget);
            }

            this.setState({
                speed: value,
                plans: []
            }, () => {
                if (this.state.formSubmitted) {
                    this.getPricing().then(() => {});
                }
            });

            globals.pushEvent(this.props.eventNameSpeed, {speed: value});
        }
    }

    handleSetAddress(address) {
        this.setState({address: address});
    }

    async submitCustomerDetails() {
        await axios.post(this.props.submitFormUrl, this.state)
            .then(() => {
                globals.pushHJEvent('/internet/business-fibre/submit');
                this.setState({formSubmitted: true});
            })
            .catch(response => {
                this.reset();
                this.setProgress(false);
                if (response.response.status === 422) {
                    this.processValidation(response.response);
                } else {
                    this.handleError(response);
                }
            });
    }

    async getPricing() {
        animations.showLoader(this);
        this.setProgress(true);
        await axios.post(this.props.getPricingUrl, {address: this.state.address, speed: this.state.speed})
            .then(result => {
                if (result.data.one_year) {
                    this.handlePricing(result.data);
                } else {
                    animations.showError(this, '#no-fibre-error');
                }
                this.setProgress(false);
            })
            .catch(response => {
                globals.handleError(response.message, response);
                animations.showError(this, '#internal-error');
                this.setProgress(false);
            });
    }

    setProgress(value) {
        this.setState({
            inProgress: value
        }, () => {
            animations.toggleSpeedButtons(value);
        });
    }

    handlePricing(data) {
        this.setState({
            plans: [
                {title: '12 Month Contract', speed: this.state.speed + 'Mbps', monthlyFee: data.one_year.monthly_rental, activationFee: data.one_year.installation, image: ''},
                {title: '24 Month Contract', speed: this.state.speed + 'Mbps', monthlyFee: data.two_years.monthly_rental, activationFee: data.two_years.installation, image: ''},
                {title: '36 Month Contract', speed: this.state.speed + 'Mbps', monthlyFee: data.three_years.monthly_rental, activationFee: data.three_years.installation, image: ''}
            ]
        }, () => {
            animations.showSuccess(this);
        });
    }

    handleCloseModal(event) {
        event.preventDefault();
        animations.closeError(this, '#no-fibre-error');
    }

    handleCloseError(event) {
        event.preventDefault();
        animations.closeError(this, '#internal-error');
    }

    processValidation(response) {
        let PartnersFormNode = findDOMNode(this),
            errors = response.data.errors;

        for (let key in errors) {
            if (key === this.honeypot || key === 'speed') {
                // do nothing
            } else {
                PartnersFormNode.querySelector('.input-' + key + ' .graphic--nao').style.stroke = 'red';
            }

            this.updateErrors(errors[key][0]);
        }

        animations.showErrors(this);
    }

    updateErrors(newError) {
        this.setState(prevState => ({
            errors: [...prevState.errors, newError]
        }));
    }

    handleError(response) {
        this.updateErrors(globals.getGenericErrorMsg());
        animations.showErrors(this);
        globals.handleError(response.message, response);
    }

    reset() {
        this.setState({errors: []});
        animations.reset(this);
    }

    render() {
        return (
            <div className="business-fibre-form" id="business-fibre-form">
                <div className="inner">
                    {this.props.children}
                    <div ref={el => this.content = el}>
                        <div id="business-fibre-anchor" />
                        <Heading title={this.props.title} subTitle={this.props.subTitle}>
                            <div className="row">
                                <div className="col-md-6 col-md-offset-3 col-xs-12 centered">
                                    {this.props.leadCopy ? <p>{this.props.leadCopy}</p> : ''}
                                </div>
                            </div>
                        </Heading>
                        <div className="row form-outer">
                            <div className="col-md-8 col-md-offset-2 col-xs-12">
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <InternetForm
                                        state={this.state}
                                        honeypot={this.honeypot}
                                        handleSetAddress={this.handleSetAddress.bind(this)}
                                        handleInputChange={this.handleInputChange.bind(this)}
                                    />
                                    <div className="animate-up form-row speed-btns">
                                        <SpeedButtons
                                            speeds={this.props.speeds}
                                            handleSpeedChange={this.handleSpeedChange.bind(this)}
                                            speed={this.state.speed}
                                        />
                                    </div>
                                    <Errors errors={this.state.errors} />
                                    <PricingBtn handleSubmit={event => this.handleSubmit(event)}>
                                        <LoaderText title="Calculating pricing" subTitle="(may take up to 20 seconds)" />
                                    </PricingBtn>
                                    <PlanResults plans={this.state.plans}>
                                        <p className="m-0 text-center">Note: prices quoted exclude GST</p>
                                        <Notice />
                                    </PlanResults>
                                    <Disclaimer1 />
                                </form>
                                <PricingError id="no-fibre-error" handleClose={this.handleCloseModal.bind(this)}>
                                    <p>Your address is not showing up as enabled for fibre at this time.</p>
                                    <p>Please give our team a call on 1300 393 835 as we do have other options.</p>
                                </PricingError>
                                <InternalPricingError handleCloseError={this.handleCloseError.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-wave-darkgreen" />
            </div>
        );
    }

}

NbnEnterpriseForm.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    leadCopy: PropTypes.string,
    speeds: PropTypes.array.isRequired,
    submitFormUrl: PropTypes.string.isRequired,
    getPricingUrl: PropTypes.string.isRequired,
    eventNameSpeed: PropTypes.string.isRequired,
    eventNameSubmit: PropTypes.string.isRequired
};

export default NbnEnterpriseForm;


// WEBPACK FOOTER //
// ./resources/assets/js/forms/NbnEnterpriseForm/NbnEnterpriseForm.js